import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setSelectedId } from "@/store/slideEditorSlice";
import type { ReactNode } from "react";
import { useSlideEditorContext } from "../SlideEditorContext";

interface EditorContainerProps {
  children: ReactNode;
}

export function EditorContainer({ children }: EditorContainerProps) {
  const dispatch = useAppDispatch();
  const { canvasSize, scale } = useAppSelector((state) => state.slideEditor.present);
  const { canvasRef } = useSlideEditorContext();

  return (
    <div
      ref={canvasRef}
      className="relative rounded-lg shadow-xl overflow-hidden bg-accent-50 flex flex-col p-3 gap-2"
      style={{
        height: canvasSize.height,
        aspectRatio: canvasSize.aspectRatio,
        transformOrigin: "center center",
        transform: `scale(${scale})`,
      }}
      onClick={() => dispatch(setSelectedId(null))}
    >
      {children}
    </div>
  );
}
